/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsstickiness1Inputs */

const en_statsstickiness1 = /** @type {(inputs: Statsstickiness1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daily stickiness`)
};

const de_statsstickiness1 = /** @type {(inputs: Statsstickiness1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tägliche Bindung`)
};

/**
* | output |
* | --- |
* | "Daily stickiness" |
*
* @param {Statsstickiness1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsstickiness1 = /** @type {((inputs?: Statsstickiness1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsstickiness1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsstickiness1(inputs)
	return de_statsstickiness1(inputs)
});
export { statsstickiness1 as "statsStickiness" }